<template>
  <!-- 🔹 ÚNICO NODO RAÍZ -->
  <div>

    <!-- CONTENIDO PRINCIPAL -->
    <div class="container">
      <div class="row">
        <div class="col">
          <h1 class="subtitulo text-center">Registro a SIFC 3.0</h1>
        </div>
      </div>

      <div class="row justify-content-center">

        <form>
          <h2 class="subtitulo text-center">DATOS:</h2>

          <div class="mb-3">
            <label>CURP(*):</label>
            <input type="text" class="form-control" maxlength="18" placeholder="CURP" v-model="curp" @input="onCurpInput"
              required />
          </div>

          <div class="mb-3">
            <label>Primer Nombre(*):</label>
            <input type="text" class="form-control" maxlength="30" placeholder="Primer Nombre" v-model="primernombre"
              @input="primernombre = primernombre.toUpperCase()" required />
          </div>

          <div class="mb-3">
            <label>Segundo Nombre:</label>
            <input type="text" class="form-control" maxlength="30" placeholder="Segundo Nombre" v-model="segunnombre"
              @input="segunnombre = segunnombre.toUpperCase()" />
          </div>

          <div class="mb-3">
            <label>Primer Apellido(*):</label>
            <input type="text" class="form-control" maxlength="25" placeholder="Primer Apellido" v-model="primape"
              @input="primape = primape.toUpperCase()" required />
          </div>

          <div class="mb-3">
            <label>Segundo Apellido:</label>
            <input type="text" class="form-control" maxlength="25" placeholder="Segundo Apellido" v-model="segape"
              @input="segape = segape.toUpperCase()" />
          </div>

          <div class="mb-3">
            <label>Teléfono Particular a 10 Dígitos(*):</label>
            <input type="text" class="form-control" maxlength="10" placeholder="Teléfono" v-model="telefono"
              oninput="this.value = this.value.replace(/[^0-9]/g, '')" required />
          </div>

          <div class="mb-3">
            <label>Correo Electrónico(*):</label>

            <div class="input-group">
              <input type="text" maxlength="40" class="form-control" placeholder="Correo Electrónico"
                v-model="emailusuario" style="text-transform: lowercase" @blur="emailcompleto" required />

              <span class="input-group-text btn bg-1 text-white">@iea.edu.mx</span>
            </div>

            <small v-if="errorEmail" class="text-danger">
              El usuario es obligatorio
            </small>
          </div>

          <div class="mb-3">
            <label>Preparación(*):</label>
            <input type="text" class="form-control" maxlength="60" placeholder="Preparación" v-model="preparacion"
              @input="preparacion = preparacion.toUpperCase()" required />

            <small class="form-text text-muted">
              EJEMPLO: LICENCIATURA EN EDUCACIÓN PREESCOLAR, MAESTRÍA, ETC.
            </small>
          </div>

          <hr />

          <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-ln-bg2 me-3" @click="accionesGuardado()" :disabled="clicked">
              Registrarme
            </button>

            <button type="button" class="btn btn-ln-bg4" @click="finSolicitud()">
              Cancelar
            </button>
          </div>
        </form>

      </div>
    </div>

    <!-- MODAL (MISMO NODO RAÍZ) -->
    <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
      aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title subtitulo">Registro Realizado Exitosamente</h1>
            <button class="btn-close" data-bs-dismiss="modal" @click="finSolicitud()"></button>
          </div>

          <div class="modal-body">
            <div class="stCard cartaInfo">
              <img src="https://eservicios2.aguascalientes.gob.mx/portalGea/iconos/i_informes.svg" class="icono" />
              <p class="titulo">Registro Realizado Exitosamente</p>

              <div class="descripcion">
                <button class="btn btn-principal" data-bs-dismiss="modal" @click="finSolicitud()">
                  NUEVO REGISTRO
                </button>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button class="btn btn-secondary" data-bs-dismiss="modal" @click="finSolicitud()">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

    
<script>
import { alert } from "@/assets/functions.js";
import { queryIEASIS } from "./backIeasis/dbContextConexion";
export default {
  name: 'Registro',
  data() {
    return {
      primernombre: '',
      segunnombre: '',

      nombrecom: '',
      emailcom: '',

      primape: '',
      segape: '',
      telefono: '',
      //email: '',
      curp: '',
      preparacion: '',

      errorEmail: false,
      emailusuario: '',

      clicked: false
    }
  },
  computed: {},

  mounted() { },
  methods: {

    filtrarEmail() {
      this.emailusuario = this.emailusuario
        .toLowerCase()
        .replace(/[^a-z0-9._-]/g, '')
    },

    onCurpInput() {
      this.curp = this.curp
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '')
        .slice(0, 18)

      if (this.curp.length === 18) {
        this.curpCompleta()
      }
    },
    async curpCompleta() {
      if (this.curp.length !== 18) { 
        alert('VERIFICA TU CURP', 'danger') 
        return 
      }  

      //console.log('CURP completa:', this.curp)
      const query = "SELECT COUNT (*) AS reg from usuarios WHERE usuario = '" + this.curp + "'"
      const res = await queryIEASIS(query)
      console.log(res[0])

      if (res[0].reg == 1) {
        alert('YA ESTAS REGISTRADO EN LA PLATAFORMA, SOLICITA APOYO A CARRERA DE MAGISTERIO SI NO PUEDES INICIAR SESIÓN', 'danger')
        this.curp = '';
      }

     

    },
    async emailcompleto() {
      this.emailusuario = this.emailusuario
        .toLowerCase()
        .replace(/[^a-z0-9._-]/g, '')

      const query = "SELECT COUNT (*) AS reg from usuarios WHERE email = '" + this.emailusuario + "@iea.edu.mx'"
      const res = await queryIEASIS(query)
      console.log(res[0])
      if (res[0].reg == 1) {
        alert('ESTE CORREO YA SE ENCUENTRA REGISTRADO EN LA PLATAFORMA, SOLICITA APOYO A CARRERA DE MAGISTERIO SI NO PUEDES INICIAR SESIÓN', 'danger')
        this.emailusuario = '';
      }

    },

    async accionesGuardado() {
      // Construcción nombre completo
      this.nombrecom = [
        this.primernombre,
        this.segunnombre
      ]
        .filter(Boolean)
        .map(n => n.trim())
        .join(' ')

      console.log(this.nombrecom)

      // Sanitizar teléfono
      this.telefono = (this.telefono || '')
        .replace(/\D/g, '')
        .slice(0, 10)

      console.log(this.telefono)

      // Validación usuario
      if (
        !this.primernombre || !this.primernombre.trim() ||
        !this.primape || !this.primape.trim() ||
        this.telefono.length !== 10 ||
        !this.curp || this.curp.length !== 18 ||
        !this.emailusuario || !this.emailusuario.trim() ||
        !this.preparacion
      ) {
        alert('VERIFICA LOS DATOS INGRESADOS', 'danger');
        return;
      }

      //Validación correo institucional
      if (
          this.emailusuario.includes('gmail') ||
          this.emailusuario.includes('hotmail') ||
          this.emailusuario.includes('yahoo') ||
          this.emailusuario.includes('nuevaescuela') ||
          this.emailusuario.includes('outlook') 
        ) {
          alert('INGRESA EL USUARIO DEL CORREO INSTITUCIONAL', 'danger')
          return
        }

      //Sanitizar email
      this.emailusuario = (this.emailusuario || '')
      .trim()
      .toLowerCase()
      .replace('@iea.edu.mx', '')
      .replace(/@/g, '')
      this.emailcom = this.emailusuario + '@iea.edu.mx'

    
      this.clicked = true;
      alert('GUARDANDO TUS DATOS, ESPERA UN MOMENTO', 'success');
      console.log(this.emailusuario)

      //INSERT
      const query =
        "INSERT INTO usuarios " +
        "(usuario, nombres, apellidop, apellidom, telefono, email, idperfil, preparacion) " +
        "VALUES (" +
        "'" + this.curp + "', " +
        "'" + this.nombrecom + "', " +
        "'" + this.primape + "', " +
        "'" + this.segape + "', " +
        "'" + this.telefono + "', " +
        "'" + this.emailcom + "', " +
        "4, " +
        "'" + this.preparacion + "'" +
        ")";

      const res = await queryIEASIS(query)
      console.log(res)

      if (res) {
        alert('REGISTRO EXITOSO, REEDIRIGIENDO A INICIAR SESIÓN', 'success')
        window.location.href = "https://sifc3.iea.edu.mx/"
      } else {
        alert('HUBO UN PROBLEMA AL PROCESAR LA INFORMACIÓN POR FAVOR INTENTAR DE NUEVO MÁS TARDE', 'danger')
      }




      /*
      } else {
        this.clicked = false;
      }
        */



    },



    finSolicitud() {
      this.$router.push('/');
      //window.location.href = "https://sifc3.iea.edu.mx/";
    }
  },
}

</script>
    
<style lang="scss" scoped></style>